module.exports = "https://www.gc-qa.gnp.com.mx/b56090e7fe8157641e1e6aca64b4f816.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo-2.png
// module id = 8147
// module chunks = 0